<template>
  <div class="hello">
        <div class="carousel-wrap">
          <div class="carousel-app">
            <img src="../assets/logo.png">
          </div>
          <div class="carousel-app-introduce">
            <div class="carousel-app-circle">
              <span class="circle" style="position: absolute;top: 20px;left: 10px">入驻</span>
              <span class="circle" style="position: absolute;top: 100px;left: 100px">注册</span>
              <span class="circle" style="position: absolute;top: 20px;left: 190px">培训</span>
              <span class="circle" style="position: absolute;top: 100px;left: 280px">派工</span>
              <span class="circle" style="position: absolute;top: 20px;left: 370px">派单</span>
              <span class="circle" style="position: absolute;top: 100px;left: 460px">保洁</span>
              <span class="circle" style="position: absolute;top: 20px;left: 540px">验收</span>
              <span class="circle" style="position: absolute;top: 100px;left: 630px">对账</span>
            </div>
            <div class="carousel-app-text">
              <p><b>注册与入住：</b><span>酒店和人力工资进行入驻信息填写和员工注册，管理员工基本信息。</span></p>
              <p><b>保洁流程管理：</b><span>从派工、派单、保洁、验收进行酒店保洁线上全流程管理。</span></p>
              <p><b>对账与结算：</b><span>系统每日、月生成对账单，进行保洁工单的核对，无需纸质核对，系统记录交易一目了然。</span></p>
              <p><b>培训与考试：</b><span>所有酒店保洁员工经过专业、体系的保洁 课程培训和考试，合格者上岗保洁。</span></p>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
    export default {
        name: 'DownLoad',
        data() {
            return {
                cooperateList: [
                    {cooperateUrl: require('../assets/hotel1.png')},
                    {cooperateUrl: require('../assets/hotel2.png')},
                    {cooperateUrl: require('../assets/hotel3.png')},
                    {cooperateUrl: require('../assets/logo.png')}
                ]
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    /*line-height: 400px;*/
    margin: 0;
  }

  .carousel-wrap {
    width: 100%;
    /* height: 500px; */
    background-color: #99a9bf;
    /* display: inline-block; */
  }

  .carousel-cooperate-list > img {
    width: 25%;
    height: 120px;
    margin: 10px 20px;
  }

  .carousel-text > h1 {
    line-height: 50px;
  }

  .carousel-text > p {
    line-height: 30px;
  }

  .carousel-code img {
    width: 150px;
    height: 150px;
  }

  .carousel-app {
    width: 40%;
    height: 400px;
    float: left;
  }

  .carousel-app-introduce {
    width: 60%;
    height: 400px;
    float: right;
  }

  .carousel-app-circle {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .circle {
    display: inline-flex;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #eee;
    color: #8d8d8d;
    justify-content: center;
    align-items: center;
  }

  .carousel-app-text {
    text-align: left;
    line-height: 40px;
  }

  .carousel-cooperate > h2 {
    line-height: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/DownLoad.vue